/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { CSSProperties, ComponentPropsWithRef, FC, ReactNode } from "react";

type Props = {
  children: ReactNode
  component?: keyof JSX.IntrinsicElements
  className?: string
  style?: CSSProperties
  [key: string]: any
}

const Stack: FC<Props> = (props) => {
  const { children, component = "div", className, style, ...rest } = props
  const Component = component
  return (
    <Component
      className={cn("flex flex-col w-full", className)}
      style={style}
      {...rest}
    >
      {children}
    </Component>
  )
};

export default Stack;
